import { Link } from "react-router-dom";
import { Mail, MessageCircle, MapPin, Phone } from "lucide-react";
import { Logo } from "@/components/Logo";
import { CONTACT_EMAIL, WHATSAPP_NUMBER, PHONE_DISPLAY } from "@/data/content";


export const Footer = () => (
    <footer className="bg-teal-dark text-cream" data-testid="site-footer">
        <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-2 lg:grid-cols-5 lg:px-10 lg:py-20">
            <div>
                <Logo light />
                <p className="mt-5 max-w-xs text-sm leading-relaxed text-cream/70">
                    High-quality live education from India, crafted for students across the world.
                </p>
            </div>
            <div>
                <h3 className="text-xs font-medium uppercase tracking-[0.24em] text-cream/50">Explore</h3>
                <ul className="mt-5 space-y-3 text-sm">
                    <li><Link to="/" className="text-cream/80 transition-colors hover:text-saffron" data-testid="footer-link-home">Home</Link></li>
                    <li><Link to="/free-trial" className="text-cream/80 transition-colors hover:text-saffron" data-testid="footer-link-trial">Free Trial Lesson</Link></li>
                    <li><Link to="/contact" className="text-cream/80 transition-colors hover:text-saffron" data-testid="footer-link-contact">Contact Us</Link></li>
                </ul>
            </div>
            <div>
                <h3 className="text-xs font-medium uppercase tracking-[0.24em] text-cream/50">Subjects</h3>
                <ul className="mt-5 space-y-3 text-sm text-cream/80" data-testid="footer-subjects">
                    <li>Hindi</li>
                    <li>English</li>
                    <li>Maths</li>
                    <li>Science</li>
                    <li>Coding</li>
                </ul>
            </div>
            <div>
                <h3 className="text-xs font-medium uppercase tracking-[0.24em] text-cream/50">Policies</h3>
                <ul className="mt-5 space-y-3 text-sm">
                    <li><Link to="/terms" className="text-cream/80 transition-colors hover:text-saffron">Terms &amp; Conditions</Link></li>
                    <li><Link to="/privacy" className="text-cream/80 transition-colors hover:text-saffron">Privacy Policy</Link></li>
                    <li><Link to="/refund-policy" className="text-cream/80 transition-colors hover:text-saffron">Refund Policy</Link></li>
                    <li><Link to="/cancellation-policy" className="text-cream/80 transition-colors hover:text-saffron">Cancellation Policy</Link></li>
                </ul>
            </div>
            <div>
                <h3 className="text-xs font-medium uppercase tracking-[0.24em] text-cream/50">Get in touch</h3>
                <ul className="mt-5 space-y-3 text-sm">
                    <li className="flex items-center gap-2.5 text-cream/80">
                        <Mail className="h-4 w-4 text-saffron" />
                        <a href={`mailto:${CONTACT_EMAIL}`} className="transition-colors hover:text-saffron" data-testid="footer-email-link">{CONTACT_EMAIL}</a>
                    </li>
                    <li className="flex items-center gap-2.5 text-cream/80">
                        <Phone className="h-4 w-4 text-saffron" />
                        <a href={`tel:+${WHATSAPP_NUMBER}`} className="transition-colors hover:text-saffron" data-testid="footer-phone-link">{PHONE_DISPLAY}</a>
                    </li>
                    <li className="flex items-center gap-2.5 text-cream/80">
                        <MessageCircle className="h-4 w-4 text-saffron" />
                        <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noreferrer" className="transition-colors hover:text-saffron" data-testid="footer-whatsapp-link">
                            Chat on WhatsApp
                        </a>
                    </li>
                    <li className="flex items-center gap-2.5 text-cream/80">
                        <MapPin className="h-4 w-4 text-saffron" />
                        Teaching from India, for the world
                    </li>
                </ul>
            </div>
        </div>
        <div className="border-t border-cream/10">
            <div className="mx-auto flex max-w-7xl flex-col gap-2 px-6 py-6 text-xs text-cream/50 md:flex-row md:items-center md:justify-between lg:px-10">
                <p>© {new Date().getFullYear()} Hindi Ganga Online Classes. All rights reserved.</p>
                <p className="font-serif italic text-cream/60">गंगा की धारा, ज्ञान की धारा — the flow of the Ganga, the flow of knowledge.</p>
            </div>
        </div>
    </footer>
);
